import React from 'react'

const ApprovalQuestionListItem = (props: any) => {
    const {title, onClick, active} = props;
  return (
    <div onClick={onClick} className={`cursor-pointer group ${active ? "!border-[#fff]" : ""} !border-l-[3px] border-[transparent] hover:!border-[#fff] px-3 py-1`}>
        <p className={`text-md text-[#A4A3B1] ${active ? "!text-[#fff]" : ""}  group-hover:!text-[#fff]`}>{title}</p>
    </div>
  )
}

export default ApprovalQuestionListItem